import React from 'react'
import { Redirect } from 'react-router-dom'

const PartialRegistrationRedirect = ({ user, location }) => {
  const acceptablePaths = ['/lgyhub/help', '/lgyhub/help/ticket', '/lgyhub/profile/contact', '/lgyhub/profile/affiliation']
  const affiliationRedirectAcceptablePaths = ['/lgyhub/help', '/lgyhub/help/ticket', '/lgyhub/profile/affiliation']
  if (user.registered && user.accountStatusCode !== 2) {
    if (!(user.primaryPhoneNumber && user.email) && !acceptablePaths.some(p => p === location.pathname)) {
      return <Redirect to={{pathname: '/lgyhub/profile/contact', state: { referer: location.pathname }}} />
    } else if (user.isAffiliate && user.affiliations && user.affiliations.length < 1 && !affiliationRedirectAcceptablePaths.some(p => p === location.pathname)) {
      return <Redirect to={{pathname: '/lgyhub/profile/affiliation', state: { referer: location.pathname }}} />
    }
  }
  return null
}

export default PartialRegistrationRedirect